import { Media, ProfileMedia, AuditionGroupMedia } from '@minecraft.graphql-operations';
import { gqlMedia, gqlProfileMedia, gqlAuditionGroupMedia, gqlMediaTypeCodeEnum } from '@minecraft.graphql-types';
import { DeepPartial } from '@minecraft.utils';
import { MediaViewerMedia } from '../types';
import { formatMediaToAudio, formatProfileMediaToAudio, formatAuditionGroupMediaToAudio } from './audioHooks';
import { formatMediaToVideo, formatProfileMediaToVideo, formatAuditionGroupMediaToVideo } from './videoHooks';

export const formatMediaToMediaViewerItem = <T extends DeepPartial<gqlMedia> | DeepPartial<Media>>({
  media,
}: {
  media: T;
}): MediaViewerMedia => {
  const keyValue = media?.mediaId || media?.id || media?.fileKey || media?.guid;
  if (media?.mediaType?.code?.toString() === gqlMediaTypeCodeEnum.AUDIO.toString()) {
    return {
      key: keyValue,
      type: gqlMediaTypeCodeEnum.AUDIO,
      audioProps: formatMediaToAudio({ media }),
    };
  }

  if (media?.mediaType?.code?.toString() === gqlMediaTypeCodeEnum.VIDEO.toString()) {
    return {
      key: keyValue,
      type: gqlMediaTypeCodeEnum.VIDEO,
      videoProps: formatMediaToVideo({ media }),
    };
  }

  return null;
};

export const formatProfileMediaToMediaViewerItem = <
  T extends DeepPartial<gqlProfileMedia> | DeepPartial<ProfileMedia>
>({
  profileMedia,
}: {
  profileMedia: T;
}): MediaViewerMedia => {
  const media = profileMedia?.media;
  const keyValue = media?.mediaId || media?.id || media?.fileKey || media?.guid;
  if (media?.mediaType?.code?.toString() === gqlMediaTypeCodeEnum.AUDIO.toString()) {
    return {
      key: keyValue,
      type: gqlMediaTypeCodeEnum.AUDIO,
      audioProps: formatProfileMediaToAudio({ profileMedia }),
    };
  }

  if (media?.mediaType?.code?.toString() === gqlMediaTypeCodeEnum.VIDEO.toString()) {
    return {
      key: keyValue,
      type: gqlMediaTypeCodeEnum.VIDEO,
      videoProps: formatProfileMediaToVideo({ profileMedia }),
    };
  }

  return null;
};

export const formatAuditionGroupMediaToMediaViewerItem = <
  T extends DeepPartial<gqlAuditionGroupMedia> | DeepPartial<AuditionGroupMedia>
>({
  groupMedia,
}: {
  groupMedia: T;
}): MediaViewerMedia => {
  const media = groupMedia?.media;
  const keyValue = media?.mediaId || media?.id || media?.fileKey || media?.guid;
  if (media?.mediaType?.code?.toString() === gqlMediaTypeCodeEnum.AUDIO.toString()) {
    return {
      key: keyValue,
      type: gqlMediaTypeCodeEnum.AUDIO,
      audioProps: formatAuditionGroupMediaToAudio({ groupMedia }),
    };
  }

  if (media?.mediaType?.code?.toString() === gqlMediaTypeCodeEnum.VIDEO.toString()) {
    return {
      key: keyValue,
      type: gqlMediaTypeCodeEnum.VIDEO,
      videoProps: formatAuditionGroupMediaToVideo({ groupMedia }),
    };
  }

  return null;
};
